import { BrowserRouter, Navigate, Route, Routes, useParams } from "react-router-dom";

import { AuthProvider } from "./auth/AuthContext.js";
import RequireAuth from "./auth/RequireAuth.js";
import EditPost from "./components/EditPost/EditPost.js";
import Feed from "./components/Feed/Feed.js";
import SharedPost from "./components/Feed/SharedPost.js";
import SinglePost from "./components/Feed/SinglePost.js";
import Join from "./components/Join/Join.js";
import Login from "./components/Login/Login.js";

// Share links handed out before routes were consolidated used /family/posts/share/...
function LegacyShareRedirect() {
  const { shareGuid } = useParams();
  return <Navigate to={`/posts/share/${shareGuid}`} replace />;
}

export function AppRoutes() {
  return (
    <Routes>
      {/* Public. The share link uses a time-bound SharePostCode GUID, not a
          post GUID, so there is no risk of exposing posts that haven't been shared. */}
      <Route path="/login" element={<Login />} />
      <Route path="/posts/share/:shareGuid" element={<SharedPost />} />
      {/* the invite code is the secret, as with share links */}
      <Route path="/join/:inviteCode" element={<Join />} />
      <Route
        path="/family/posts/share/:shareGuid"
        element={<LegacyShareRedirect />}
      />

      <Route element={<RequireAuth />}>
        <Route path="/" element={<Feed />} />
        <Route path="/edit/:postGuid" element={<EditPost />} />
        <Route path="/post/:postGuid" element={<SinglePost />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
